import axios from 'axios';
import api from './api';
import { pedidoComVideos } from '../components/ManutencaoEvidencia';

// Sem sessão interna nem redirecionamento para login.
const publicApi = axios.create({ baseURL: api.defaults.baseURL, timeout: 60000 });
export const novoIdSubmissao = () => {
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const h = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};
export const obterOrdem = async token => (await publicApi.get(`/manutencao/public/${encodeURIComponent(token)}`)).data;
export const submeterFicha = async (token, payload, videos) => (await publicApi.post(
    `/manutencao/public/${encodeURIComponent(token)}/fichas`, pedidoComVideos(payload, videos),
    { timeout: videos.length ? 180000 : 60000 },
)).data;
export const urlPdfExterno = resultado => new URL(
    `${api.defaults.baseURL}/manutencao/relatorio/${resultado.id}?t=${encodeURIComponent(resultado.share_token)}`,
    window.location.origin,
).href;
export const abrirPdfExterno = resultado => window.open(urlPdfExterno(resultado), '_blank', 'noopener,noreferrer');
